import styled, { keyframes } from 'styled-components';
import { Icon } from '../../Icons';
const fadeInAnimation = keyframes `
    0% { opacity: 1; transform: scale(1) }
    100% { opacity: 0; transform: scale(1.5) }
`;
export const FeedBackIcon = styled(Icon) `
    width: 70px;
`;
export const Circle = styled.div `
    width: 120px;
    height: 120px;
    background: #000000a3;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    animation-name: ${fadeInAnimation};
    animation-duration: ${(props) => props.duration}ms;
`;
//# sourceMappingURL=index.js.map